import BrandSubscriptionServiceCallState from '../store/schema/BrandSubscriptionServiceCallState';
import datapoints from '../datapoints';
import { GetBrandsSubscriptionsServiceResponse } from 'owa-brands-subscription';
import { action } from 'satcheljs';

const setServiceCallState = action(
    'SET_SERVICE_CALL_STATE',
    (state: BrandSubscriptionServiceCallState) => ({
        state: state,
    })
);

const loadBrandsSubscriptions = action('LOAD_BRANDS_SUBSCRIPTIONS', () => ({
    datapointConfig: {
        name: datapoints.LoadBrandsSubscriptions.datapoint.name,
    },
}));

const updateBrandsSubscriptions = action(
    'UPDATE_BRANDS_SUBSCRIPTIONS',
    (response: GetBrandsSubscriptionsServiceResponse) => ({
        response: response,
    })
);

const onUnsubscribeFromBrand = action('ON_UNSUBSCRIBE_FROM_BRAND', (smtpIdentifier: string) => ({
    smtpIdentifier: smtpIdentifier,
}));

export {
    setServiceCallState,
    loadBrandsSubscriptions,
    updateBrandsSubscriptions,
    onUnsubscribeFromBrand,
};
